import React from "react";
import { useFilterContext } from "../../contexts/FilterContext";
import { useTranslation } from "react-i18next";

const ResetFilters = ({ className, text }) => {
  const { t } = useTranslation();
  const { resetFilters } = useFilterContext();
  return (
    <button
      onClick={resetFilters}
      className={`btn btn-primary btn-medium ${className}`}
    >
      {t(text ?? "Reset Filters")}
    </button>
  );
};

export default ResetFilters;
